const ROLES = {
    ADMIN: 'admin',
    FINANCE: 'finance',
    SALE: 'sale',
    OP: 'op',
    TELESALES: 'telesales',
};

export const ACCESS_ROLES = {
    /** ทุก role ยกเว้น finance — ซ่อนเมนูงานขาย/การตลาดจากการเงิน (user เคาะ 2 ก.ย. 2569) */
    NO_FINANCE: [ROLES.ADMIN, ROLES.SALE, ROLES.OP, ROLES.TELESALES],
    /** กลุ่ม Finance Management เดิม — เหลือ admin (การเงินย้ายไปใช้เมนู งานการเงิน + Order List (Finance Only)) */
    FINANCE_MANAGEMENT_LEGACY: [ROLES.ADMIN],
    ALL: [ROLES.ADMIN, ROLES.FINANCE, ROLES.SALE, ROLES.OP, ROLES.TELESALES],
    DASHBOARD: [ROLES.ADMIN, ROLES.TELESALES],
    PROGRAM_TOUR_LIST_PAGE: [ROLES.ADMIN, ROLES.SALE, ROLES.OP, ROLES.TELESALES], // finance ออก 2 ก.ย. 2569 (คุมทั้งเมนู+route)
    WORKLIST_GROUP: [ROLES.ADMIN, ROLES.SALE, ROLES.FINANCE, ROLES.TELESALES],
    CASH_INFLOW_REPORT: [ROLES.ADMIN, ROLES.FINANCE],
    FINANCE_MANAGEMENT_GROUP: [ROLES.ADMIN, ROLES.FINANCE],
    PRODUCT_MANAGEMENT_GROUP: [ROLES.ADMIN],
    PIPELINE_MANAGEMENT_GROUP: [ROLES.ADMIN],
    CUSTOMER_RELATION_LIST: [ROLES.ADMIN, ROLES.TELESALES],
    AI_SETTING: [ROLES.ADMIN],
    /** จองยกเลิกฟรี: เฝ้ารอบ + ตั้งค่า/โหมดซ้อม = admin เท่านั้น (เจ้าของเคาะ 21 ก.ย. 2569) */
    PREBOOK_ADMIN: [ROLES.ADMIN],
    MESSAGING_API: [ROLES.ADMIN],
    CUSTOMER_MANAGEMENT: [ROLES.ADMIN],
    ORDER_CREATE_PAGE: [ROLES.ADMIN, ROLES.SALE, ROLES.FINANCE, ROLES.OP, ROLES.TELESALES],
    ORDER_EDIT_PAGE: [ROLES.ADMIN, ROLES.SALE, ROLES.FINANCE, ROLES.OP, ROLES.TELESALES],
    //
    ORDER_LIST_PAGE: [ROLES.ADMIN, ROLES.FINANCE],
    ORDER_PROGRAM_LIST_PAGE: [ROLES.ADMIN, ROLES.FINANCE],
    ORDER_BALANCE_LIST_PAGE: [ROLES.ADMIN, ROLES.FINANCE],
    AGENCY_COMMISSION_PAGE: [ROLES.ADMIN, ROLES.FINANCE],
    ORDER_VOUCHER_LIST_PAGE: [ROLES.ADMIN, ROLES.FINANCE],
    SELLER_VOUCHER_PAGE: [ROLES.ADMIN, ROLES.FINANCE],
    FEE_LIST_PAGE: [ROLES.ADMIN, ROLES.FINANCE],
    TOURWOW_FEE_PAGE: [ROLES.ADMIN, ROLES.FINANCE],
    TW_ORDER_LIST_PAGE: [ROLES.ADMIN, ROLES.FINANCE],
    //
    KEYWORD_LIST_PAGE: [ROLES.ADMIN],
    KEYWORD_PAGE: [ROLES.ADMIN],
    TW_ORDER_MATCHING_LIST_PAGE: [ROLES.ADMIN],
    PERIOD_MANAGEMENT_LIST_PAGE: [ROLES.ADMIN],
    CASH_OUTFLOW_REPORT_LIST_PAGE: [ROLES.ADMIN, ROLES.FINANCE],
    COUNT_LEADS_REPORT: [ROLES.ADMIN, ROLES.SALE, ROLES.OP, ROLES.TELESALES], // finance ออก 2 ก.ย. 2569
    SURVEY_REPORT: [ROLES.ADMIN, ROLES.FINANCE, ROLES.SALE, ROLES.OP, ROLES.TELESALES],
    OTP_LOGIN_REPORT: [ROLES.ADMIN],
    CRM_KPI_REPORT: [ROLES.ADMIN, ROLES.FINANCE, ROLES.SALE, ROLES.OP, ROLES.TELESALES],
    //
    LEAD_DETAIL_PAGE: [ROLES.ADMIN, ROLES.SALE, ROLES.FINANCE, ROLES.OP, ROLES.TELESALES],
    TELESALES_REPORT: [ROLES.ADMIN],
    ORDERS_MANAGEMENT: [ROLES.ADMIN],
    ORDERS_COUNT_REPORT: [ROLES.ADMIN],
    ORDER_REPORT_FOR_WHOLESALE_PAYMENT: [ROLES.ADMIN], // finance ออก 2 ก.ย. 2569
    TRACKING_LEADS_REPORT: [ROLES.ADMIN, ROLES.OP],
    TRACKING_REPORT: [ROLES.ADMIN],
    PROMOTION_LIST: [ROLES.ADMIN],
    SITEMAP_LIST: [ROLES.ADMIN],

    CUSTOMER_LIST: [ROLES.ADMIN, ROLES.TELESALES],
    RD_FOR_IT: [ROLES.ADMIN, ROLES.FINANCE],
    PAGE_CONFIG: [ROLES.ADMIN, ROLES.FINANCE],
};
